// stores/message.js
import { defineStore } from 'pinia';

export const useMessageStore = defineStore('message', {
    state: () => ({
        message: '',
        type: '', // 'error', 'warning', 'success'
    }),
    actions: {
        setMessage(message, type) {
            this.message = message;
            this.type = type;
        },
        clearMessage() {
            this.message = '';
            this.type = '';
        },
    },
});
